.Main {
    position: relative;
    pointer-events: none;
    font-weight: normal;
    font-size: min(23vw, var(--max-font-size, 23vw));
    line-height: 0.8;
    letter-spacing: -0.03em;
    word-spacing: 0.3em;
    font-variation-settings: "wght" 400;
    left: -0.15em;
    width: calc(100% + 0.3em);
    box-sizing: border-box;
}

.Small {
    font-size: 15vw;
    line-height: 0.865;
}

.Main h1,
.Main h2,
.Main h3,
.Main h4,
.Main h5,
.Main h6 {
    line-height: 0.8;
}

.IsVisible .Canvas {
    opacity: 1;
    transform: scale(1);
}

.Title {
    position: relative;
    display: inline-block;
    padding: 0.1em 0.3em 0.2em 0.3em;
    box-sizing: border-box;
}

.Line {
    position: relative;
    display: inline-block;
}

.Word {
    position: relative;
    display: inline-block;
    white-space: pre;
    transform-origin: center center;
    will-change: transform;
    opacity: 0.001;

    :global(body.simulator) & {
    opacity:1;
    }
}

@media (min-width: 768px) {
    .Main {
        left: -0.25em;
        width: calc(100% + 0.5em);
        font-size: min(20vw, var(--max-font-size, 20vw));
    }

    .Small {
        font-size: 10vw;
    }
}

